import { Component, ElementRef, HostListener, Inject, Input, OnInit, ViewChild } from "@angular/core";
import { AJSRootScope, downgradeToAJSComponent } from 'ib-web-commons/utils';
import { IbGastronomicProposalUtilsService } from "../../services/ib-gastronomic-proposal-utils.service";
import { IbDigitalMenuService } from "../../services/ib-digital-menu.service";
import { IGastroProposalFlightsModel } from "../../models/gastronomic-proposal.model";
import { IDigitalMenuData, IDigitalMenuRequest, IErrorData, ILoadingPDF } from "../../models/digital-menu.model";
import { AJSMmBDatalayerUtilsService, AJSMmBDatalayerUtilsServiceType } from "@src/components/services/ib-MmB-datalayer/services/ib-MmB-datalayer-utils-service-bridge.service";
import { MMBDatalayerConstants } from "@src/components/services/ib-MmB-datalayer/constants/ib-MmB-datalayer-constants";
import { MmBAppConstants } from "@src/ib-MmB-constants";

@Component({
    selector: 'ib-digital-menu-modal',
    templateUrl: './ib-digital-menu-modal.component.html',
    styleUrls: ['ib-digital-menu-modal.component.scss'],
})

export class IbDigitalMenuModalComponent {


    readonly imgRoute = `${this.$rootScope.routes.images}/preselection/menu_07.png`;
    readonly imgRouteMobile = `${this.$rootScope.routes.images}/preselection/menu_07_mobile.png`;
    collapsed = true;
    loadingPDF: ILoadingPDF = {
        loading: false,
        error: false
    };
    flightSelected!: IGastroProposalFlightsModel;
    digitalMenuData: IDigitalMenuData | null = null;
    isMobile: boolean;

    @Input() digitalMenuOption!: any;
    @Input() showNextFlightButton: boolean;

    @ViewChild('triggerDM') triggerDM: ElementRef<HTMLSpanElement>;

    constructor(
        @Inject(AJSRootScope) private $rootScope: any,
        private ibGastronomicProposalUtils: IbGastronomicProposalUtilsService,
        private ibDigitalMenuService: IbDigitalMenuService,
        @Inject(AJSMmBDatalayerUtilsService) private MmBDatalayerUtilsService: AJSMmBDatalayerUtilsServiceType,
    ) {
        this.ibDigitalMenuService.flightTabSelected$.subscribe(flight => this.flightSelected = flight);
        this.ibDigitalMenuService.loadingPDF$.subscribe(response => this.loadingPDF = response);
        this.isMobile = screen.width < 480 ? true : false;
    }
    @HostListener('window:resize', ['$event'])
    onResize(event: any): void {
        this.isMobile = event.target.innerWidth < 480 ? true : false;
    }

    closeAll() {
        this.ibGastronomicProposalUtils.closeAll();
        this.closeModal();
    }

    closeModal() {
        this.collapsed = true;
        this.resetDigitalMenuData();
    }

    resetDigitalMenuData() {
        this.digitalMenuData = null;
    }

    openSpecialMeals() {
        this.ibGastronomicProposalUtils.openSpecialMeals();
        this.MmBDatalayerUtilsService.updateDatalayerEvents(MMBDatalayerConstants.GASTRONOMIC_EVENT_CATEGORY_VALUES.GASTRONOMIC_PROPOSAL, MMBDatalayerConstants.DATALAYER_EVENT_TYPES.CLIC, this.getEventLabel('Comidas Especiales'), MMBDatalayerConstants.DatalayerGeneralConstants.EVENT_NAME_INTERACTION);
    }

    showDigitalMenu() {
        const request: IDigitalMenuRequest = this.ibDigitalMenuService.getRequestDM(this.flightSelected);
        this.setLoadingPDF(true);
        this.showOverlayModal(true);
        this.ibDigitalMenuService.retrieveDigitalMenu(request).subscribe({
            next: response => {
                this.digitalMenuData = response.data;
                this.showOverlayModal(false);
                this.openDigitalMenuModal();
                this.updateQuadrigam();
            },
            error: error => this.showOverlayModal(false, true, error?.error?.errors)
        });
        this.ibDigitalMenuService.retrievePDFData(request);
        this.ibGastronomicProposalUtils.updateDatalayerOption('DIGITAL_MENU');
    }

    dowloadMenuPDF() {
        this.ibDigitalMenuService.dowloadMenuPDF();
        this.MmBDatalayerUtilsService.updateDatalayerEvents(MMBDatalayerConstants.GASTRONOMIC_EVENT_CATEGORY_VALUES.GASTRONOMIC_PROPOSAL, MMBDatalayerConstants.DATALAYER_EVENT_TYPES.CLIC, this.getEventLabel('descargar menu'), MMBDatalayerConstants.DatalayerGeneralConstants.EVENT_NAME_INTERACTION);
    }

    goToNextFligthOptions() {
        this.resetDigitalMenuData();
        this.ibGastronomicProposalUtils.goToNextFligthOptions();
    }

    private openDigitalMenuModal() {
        this.triggerDM.nativeElement.click();
    }

    private showOverlayModal(loading: boolean, error: boolean = false, errorData: IErrorData[] = []) {
        this.ibDigitalMenuService.setOverlayModalStatus({ showLoading: loading, showError: error, errorData });
    }

    private setLoadingPDF(value: boolean) {
        this.loadingPDF.loading = value;
    }

    private updateQuadrigam() {
        const quadrigam = MmBAppConstants.QUADRIGAM.MODA_DIGITAL_MENU;
        this.MmBDatalayerUtilsService.updateDatalayerInfo(MMBDatalayerConstants.DIGITAL_DATA_PROCESS[quadrigam], MMBDatalayerConstants.DIGITAL_DATA_STEP[quadrigam], quadrigam);
        this.MmBDatalayerUtilsService.updateDatalayerViewEvent();
    }

    private getEventLabel(action: string) {
        return `tab vuelo:${this.flightSelected.departure.code}|${this.flightSelected.arrival.code}:ver menu:${action}`;
    }

}

downgradeToAJSComponent('ibDigitalMenuModal', {
    component: IbDigitalMenuModalComponent,
    inputs: ['digitalMenuOption', 'showNextFlightButton']
}, 'ib-MmB-gastronomic-proposal-module');
